import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Reveal, MaskLines } from "../components/Reveal";

const PRIVACY_SECTIONS = [
  {
    title: "Introduction",
    body: "Dhara Kala Movies (‘we’, ‘us’, ‘our’) respects your privacy. This policy explains what information we collect when you visit dharakalamovies.com, how we use it, and the choices available to you.",
  },
  {
    title: "Information We Collect",
    body: "We collect only the information you voluntarily provide — for example, when you contact us through the inquiry form or subscribe to our newsletter. This may include your name, email address, organisation, country and message content.",
  },
  {
    title: "How We Use Information",
    body: "Information is used solely to respond to inquiries, share festival updates you have opted into, and improve our correspondence with collaborators, press and festivals. We do not sell or rent your information to third parties.",
  },
  {
    title: "Cookies & Analytics",
    body: "Our website uses minimal, non-invasive cookies where technically necessary. If aggregate analytics are enabled in the future, they will be anonymised and used only to understand general audience trends.",
  },
  {
    title: "Data Retention",
    body: "Inquiry emails are retained only as long as necessary to respond and archive project-related correspondence. Newsletter subscribers can unsubscribe at any time via the link in each mailing.",
  },
  {
    title: "Contact",
    body: "For any privacy-related question, please write to dharakala@outlook.com.",
  },
];

export default function Privacy() {
  return (
    <main data-testid="privacy-page" className="bg-black pt-32 md:pt-40 min-h-screen">
      <section className="max-w-[1200px] mx-auto px-6 md:px-10 pb-16">
        <Link to="/" className="text-[11px] uppercase tracking-overline text-white/60 hover:text-white inline-flex items-center gap-2 mb-8">
          <ArrowLeft size={14} /> Home
        </Link>
        <p className="text-[10px] uppercase tracking-overline text-[color:var(--dk-gold)] mb-6">Privacy Policy</p>
        <h1 className="font-serif-display font-light text-white text-6xl md:text-8xl leading-[0.9] tracking-tighter">
          <MaskLines lines={["Privacy,", "briefly."]} />
        </h1>
        <Reveal delay={1} className="mt-8 text-white/50 text-sm">Last updated: December 2026</Reveal>
      </section>

      <section className="max-w-[1200px] mx-auto px-6 md:px-10 pb-28 space-y-14">
        {PRIVACY_SECTIONS.map((s, i) => (
          <Reveal key={i} delay={i % 3} className="grid grid-cols-1 md:grid-cols-12 gap-6 border-t border-white/10 pt-10">
            <p className="md:col-span-2 text-[10px] uppercase tracking-overline text-[color:var(--dk-gold)]/70">
              0{i + 1}
            </p>
            <div className="md:col-span-10">
              <h2 className="font-serif-display text-white text-2xl md:text-3xl mb-4">{s.title}</h2>
              <p className="text-white/70 leading-relaxed max-w-3xl">{s.body}</p>
            </div>
          </Reveal>
        ))}
      </section>
    </main>
  );
}
